import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { withTheme } from 'styled-components'
import { Tabs, Modal, message } from 'antd'
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import moment from 'moment'

// Import the BillUpload component
import BillUpload from './BillUpload'
import { USERDEFAULTS_SAVE_FLAG, addDataToStore } from '../../../Actions/actions'
import { Flex, FlexColumn } from '../../Reusable/Container'
import PageHeader from '../../Reusable/PageHeader'
import ViewBill from './ViewBill'
import ConnectionModal from '../../Reusable/ConnectionModal'
import ModalClose from '../../../Images/modal-close.png'
import Inbox from './Inbox/Index'
import BillTable from './BillTable'
import SearchAndFilter from './SearchFilter'
import { Button } from '../../Reusable/Button'
import { Image } from '../../Reusable/Image'
import { ErrorAlert } from '../../Reusable/Alert'
import AlertModal from '../../Reusable/AlertModal'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'
import { getUserApps } from '../../../Utils/util'

const { TabPane } = Tabs
const { confirm } = Modal
var dFormat = "YYYY-MM-DD"

class Index extends Component {
    state = {
        activeKey: this.props.userDefaultsStore.BillsActiveTab || "New",
        categories: [],
        showDelete: false,
        showCancel: false,
        billToDelete: null,
        billToCancel: null,
        deleteLoading: false,
        cancelLoading: false,
        showViewBillModal: false,
        billToView: null,
        searchTerm: '',
        selectedVendorId: null,
        fromDate: null,
        toDate: null,
        fromAmount: null,
        toAmount: null,
        // Bill upload state
        showUploadModal: false,
        dragDropMode: true
    }

    componentDidMount() {
        const { userDefaultsStore } = this.props;
        this.onChangeTab(userDefaultsStore.BillsActiveTab || this.state.activeKey);
        this.fetchCOA();
    }

    fetchCOA = () => {
        const headers = {
            AionCurrentBiz: this.props.aionStore.BusinessUniqueKey,
            AionAuth: this.props.aionStore.UAM.encryptedAuthHeader
        }
        
        const body = {
            "BusinessId": this.props.aionStore.BusinessUniqueKey,
            "size": 200,
            "page": 0,
            "ActiveRecords": true,
            "sortFieldName": "Code",
            "sortDirection": "ASC"
        }
        
        apiPOSTReq(`${environment.bbBaseUrl}/bk/getCategories`, headers, body, (err, resp) => {
            try {
                const data = resp;
                if (data.result) {
                    this.setState({
                        categories: (data.systemCOAList || []).concat(data.customCOAList),
                    });
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                }
            } catch (error) {
                console.log("ERROR getActiveCustomers", error.stack, resp);
                ErrorAlert({ description: error.message });
            }
        });
    }

    onChangeTab = (activeKey) => {
        this.props.dispatch(addDataToStore(USERDEFAULTS_SAVE_FLAG, { BillsActiveTab: activeKey }));
        this.setState({ 
            activeKey, 
            searchTerm: '', 
            selectedVendorId: null, 
            fromDate: null,
            toDate: null,
            fromAmount: null,
            toAmount: null
        });
    }

    handleNewBillFlow = () => {
        // Show upload modal instead of directly navigating
        this.setState({ showUploadModal: true });
    }

    handleManualBillCreation = () => {
        this.setState({ showUploadModal: false });
        this.props.history.push('/payables/bills/new-bill');
    }
    
    handleUploadSuccess = () => {
        // Close modal
        this.setState({ showUploadModal: false });
        
        // Switch to the "New" tab (Inbox) and refresh
        this.onChangeTab("New");
        
        // Force a refresh after switching tabs
        setTimeout(() => {
            this.setState({ lastRefresh: Date.now() });
        }, 100);
    }
    
    // Toggle drag-drop mode
    toggleDragDropMode = () => {
        this.setState(prevState => ({
            dragDropMode: !prevState.dragDropMode
        }));
    }
    
    // Show upload modal
    showUploadModal = () => {
        this.setState({ showUploadModal: true });
    }

    handlePayBill = (bill) => {
        const { categories } = this.state;

        if (bill.vendorId) {
            this.props.history.push({
                pathname: `/payables/bills/view/${bill?.id}`,
                state: { bill, payFlow: true }
            });
        } else {
            const callback = () => {
                let category;
                if (bill.coaid) {
                    category = categories.find(obj => obj.id === bill.coaid);
                }

                this.props.history.push({
                    pathname: '/payables/bills/edit',
                    state: { bill, category, edit: true }
                });
            };

            confirm({
                title: 'No vendor',
                icon: <ExclamationCircleOutlined />,
                content: "You haven't set a vendor for this bill. Click 'OK' to edit your bill and set one now.",
                onOk() {
                    callback();
                },
                onCancel() {},
            });
        }
    }

    handleRescheduleBill = (bill) => {
        this.props.history.push({
            pathname: '/payables/bills/reschedule',
            state: { bill }
        });
    }

    deleteBill = (id, invoiceNumber) => {
        this.setState({ deleteLoading: true });
        if (!invoiceNumber) {
            invoiceNumber = "";
        }
        
        apiPOSTReq(`${environment.payBaseUrl}/payables/bills/delete`, 
            { "BankProvider": environment.bankProvider.crb }, 
            { billId: id }, 
            (err, resp) => {
                try {
                    const data = resp;
                    if (data.result) {
                        message.success(`Bill ${invoiceNumber} is deleted`);
                        // Force refresh of the bill table by updating state
                        this.setState({
                            lastRefresh: Date.now()
                        });
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                    }
                } catch (error) {
                    console.log("ERROR /payables/bills/delete", error, err, resp);
                    ErrorAlert({ description: error.message });
                } finally {
                    this.setState({ deleteLoading: false, showDelete: false, billToDelete: null });
                }
            }
        );
    }

    cancelBillPayment = (id) => {
        this.setState({ cancelLoading: true });
        
        apiPOSTReq(`${environment.payBaseUrl}/payables/cancelBillSchedule`, 
            { "BankProvider": environment.bankProvider.crb }, 
            { billId: id }, 
            (err, resp) => {
                try {
                    const data = resp;
                    if (data.result) {
                        // Force refresh of the bill table by updating state
                        this.setState({
                            lastRefresh: Date.now()
                        });
                    } else {
                        throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later");
                    }
                } catch (error) {
                    console.log("ERROR /payables/cancelBillSchedule", error, err, resp);
                    ErrorAlert({ description: error.message });
                } finally {
                    this.setState({ cancelLoading: false, showCancel: false, billToCancel: null });
                }
            }
        );
    }

    handleSearchFilterChange = (options) => {
        this.setState({
            searchTerm: options.searchTerm || '',
            selectedVendorId: options.vendorId || null,
            fromDate: options.fromDate || null,
            toDate: options.toDate || null,
            fromAmount: options.fromAmount || null,
            toAmount: options.toAmount || null
        });
    }

    render() {
        const { 
            activeKey, 
            showDelete, 
            showCancel, 
            billToDelete, 
            billToCancel, 
            deleteLoading, 
            cancelLoading,
            showViewBillModal,
            billToView,
            vendor,
            categories,
            searchTerm,
            selectedVendorId,
            fromDate,
            toDate,
            fromAmount,
            toAmount,
            lastRefresh,
            // Bill upload state
            showUploadModal,
            dragDropMode
        } = this.state;
        
        const { theme, aionStore } = this.props;
        
        // Check if QBO integration is active
        const userApps = getUserApps(aionStore);
        const { CurrentSync } = aionStore;
        let qbo = false;
        if (CurrentSync && CurrentSync.platformName === 'QUICKBOOKS' && 
            CurrentSync.syncSetupCompleted && userApps && userApps.includes("Payables")) {
            qbo = true;
        }

        return (
            <div className="bill-payments-container" style={{ width: '100%' }}>
                {/* Bill Upload Component */}
                <BillUpload
                    visible={showUploadModal}
                    enableGlobalDrop={!showUploadModal}
                    aionStore={aionStore}
                    onCancel={() => this.setState({ showUploadModal: false })}
                    onManualCreate={this.handleManualBillCreation}
                    onUploadSuccess={this.handleUploadSuccess}
                    onShowModal={this.showUploadModal}
                    destroyOnClose={true}
                />
                
                {/* Main Content */}
                <FlexColumn start className='main-padding' style={{ width: '100%' }}>
                    <PageHeader
                        titleText="Bill Payments"
                        desc="List of all your bills"
                    />

                    <Tabs 
                        defaultActiveKey="Unpaid" 
                        activeKey={activeKey} 
                        onChange={this.onChangeTab} 
                        style={{ marginBottom: 12, width: '100%' }} 
                        tabBarExtraContent={
                            <Flex style={{ gap: '12px' }}>
                                <Button 
                                    solid 
                                    onClick={this.handleNewBillFlow} 
                                    text="ADD BILL" 
                                    icon={<PlusOutlined style={{ color: theme.colors.body }} />} 
                                />
                            </Flex>
                        }
                    >
                        <TabPane tab="Inbox" key="New" />
                        <TabPane tab="Unpaid" key="Unpaid" />
                        <TabPane tab="Scheduled" key="Scheduled" />
                        <TabPane tab="All" key="All" />
                        <TabPane tab="Archived" key="Archive" />
                    </Tabs>

                    {
                        ["New", "Archive"].includes(activeKey) &&
                        <Inbox
                            key={`${activeKey}-${lastRefresh}`}
                            selectedTab={activeKey} 
                            location={this.props.location} 
                            history={this.props.history}
                        />
                    }
                    {
                        ["Unpaid", "Scheduled", "All"].includes(activeKey) &&
                        <BillTable
                            key={`${activeKey}-${lastRefresh}`}
                            activeTab={activeKey}
                            titleText="Bills"
                            enableFiltering={true}
                            deleteBill={(bill) => this.setState({ billToDelete: bill, showDelete: true })}
                            handleRescheduleBill={this.handleRescheduleBill}
                            cancelBillPayment={(bill) => this.setState({ billToCancel: bill, showCancel: true })}
                            deleteLoading={deleteLoading}
                            cancelLoading={cancelLoading}
                        />
                    }
                </FlexColumn>

                {/* Modals */}
                <Modal
                    visible={showViewBillModal}
                    footer={null}
                    closable={true}
                    maskClosable={true}
                    width={(billToView || {}).previewDocumentUrls && billToView.previewDocumentUrls.length > 0 ? 1050 : 700}
                    style={{ top: 20 }}
                    destroyOnClose={true}
                    onCancel={() => this.setState({ showViewBillModal: false, billToView: null })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <ViewBill
                        bill={billToView}
                        vendor={vendor}
                        categories={categories}
                    />
                </Modal>

                <AlertModal
                    deactivate
                    visible={showDelete}
                    loading={deleteLoading}
                    title='Delete this bill?'
                    description={<>
                        <div>Are you sure you want to delete this bill?</div>
                        {qbo && billToDelete?.source === 'QUICKBOOKS' && <div>This will also delete the bill on QuickBooks Online</div>}
                    </>}
                    descWidth={'350px'}
                    buttonTitle='DELETE'
                    cancelButtonText='CANCEL'
                    onConfirm={() => {
                        this.deleteBill(billToDelete?.id, billToDelete?.invoiceNumber);
                    }}
                    onCancel={() => this.setState({ showDelete: false, billToDelete: null })}
                />

                <AlertModal
                    deactivate
                    visible={showCancel}
                    loading={cancelLoading}
                    title='Cancel this bill payment?'
                    description={"This will cancel all scheduled payments. Are you sure you want to proceed?"}
                    buttonTitle='CANCEL'
                    cancelButtonText='CLOSE'
                    onConfirm={() => {
                        this.cancelBillPayment(billToCancel?.id);
                    }}
                    onCancel={() => this.setState({ showCancel: false, billToCancel: null })}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        aionStore: state.aionAppReducer,
        userDefaultsStore: state.userDefaultsReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)));